<div class="container custom-column-spacing">
    <div>
        <label> {{ appConstants.documentPendingSignatureTitle }} </label>
        <thera-client-side-list
            class="w-full"
            [hideGridLines]="true"
            [columnDefs]="columnDefinition"
            [rowData]="pendingRecordsRowrowData"
        >
        </thera-client-side-list>
    </div>
    <div>
        <label> {{ appConstants.documentRejectedSignatureTitle }} </label>
        <thera-client-side-list
            class="w-full"
            [hideGridLines]="true"
            [columnDefs]="columnDefinition"
            [rowData]="rejectedRecordsRowData"
        >
        </thera-client-side-list>
    </div>
</div>